<div class="new-vetcor-table-styles">
   <div
      class="content container-fluid"
      style="padding-left: 10px; padding-right: 10px; padding-top: 20px; padding-bottom: 0px">
      <div class="project-task">
         <ul
            class="nav nav-tabs nav-tabs-top mb-0"
            style="display: inline-flex">
            <li
               class="nav-item"
               style="margin-bottom: 0px">
               <a
                  class="nav-link active"
                  style="padding: 18px"
                  href="#all_tasks"
                  data-bs-toggle="tab"
                  aria-expanded="true">
                  <i
                     class="fa fa-briefcase"
                     style="color: transparent; -webkit-text-stroke-width: 0.7px"></i>
                  Product | Service Lookup
               </a>
            </li>
            <li
               class="nav-item"
               style="margin-bottom: 0px">
               <a
                  class="nav-link"
                  style="padding: 18px"
                  href="#request_tasks"
                  data-bs-toggle="tab"
                  aria-expanded="false">
                  <i class="fa fa-tasks"></i>
                  Product Review Requests
               </a>
            </li>
         </ul>

         <div style="display: inline-flex; float: right; margin-right: 5px">
            <button
			   type="button"
			   class="v-button v-button-md v-green"
			   (click)="showCSVModal(false)">
			   <i class="pi pi-upload"></i>
			   &nbsp;&nbsp;Update <strong>Products</strong> Import CSV
			</button>

            <p-dialog
               [(visible)]="displayCSVModal"
               [modal]="true"
			   header="Upload CSV"
			   class="m-0"
               [closable]="true"
               [style]="{ width: '70vw' }"
               (onHide)="handleCloseButton()">
			   
			   <div *ngIf="isVCImport" class="dialog-label text-left mb-4">
			      Upload your CSV file in UTF-8 format to update multiple VC Products.<br>
				  <span class="csv-small-font">
				     * Please make sure the <i>Type</i> column has a <i>1</i> for products/inventory or <i>2</i> for a service.
				  </span>
			   </div>
			   
			   <div *ngIf="!isVCImport" class="dialog-label text-left mb-4">
			      Upload your CSV file in UTF-8 format to update multiple products.
			   </div>
			   
			   <div class="text-right mb-2">
			      <a 
				     [href]="isVCImport ? 'assets/csv-samples/VCProductsImport-sample.csv' : 'assets/csv-samples/ProductsImport-sample.csv'"
                     class="textlink">
                     <i class="pi pi-download"></i>
					 &nbsp;&nbsp;Download Sample CSV
                  </a>
			   </div>
			   
               <div class="upload-box">
			      <i class="fa fa-cloud-upload"></i>
				  <br>
				  <div class="dragText">
				     Drag and drop your CSV or Browse
				  </div>
			   
                  <div class="fileSelector">
                     <input
                        #csvFileInput
						type="file"
                        (change)="onFileChange($event)"
                        accept=".csv" />
                  </div>

                  <!-- Show loading bar if loading, otherwise show the message -->
                  <div
                     *ngIf="batchCSCLoading"
                     class="batch-loading-bar">
                     <p-progressBar mode="indeterminate"></p-progressBar>
                  </div>

                  <div
                     *ngIf="batchSuccessMessage"
                     class="batch-success-message"
                     style="font-size: 13px; font-weight: 600">
                     <p [innerHTML]="batchSuccessMessage"></p>
                  </div>

                  <div
                     *ngIf="batchErrorMessages.length > 0"
                     class="batch-success-message">
                     <ul style="display: flex; flex-flow: wrap; padding-inline-start: 0px">
                        <li
                           *ngFor="let message of batchErrorMessages"
						   [class]="isVCImport ? 'vcproducts-error-message' : 'products-error-message'">
                           {{ message }}
                        </li>
                     </ul>
                  </div>
               </div>

               <ng-template pTemplate="footer">
                  <button
                     pButton
                     type="button"
                     label="Update Products"
                     icon="pi pi-refresh"
                     [disabled]="!csvUploaded"
                     [style.opacity]="csvUploaded ? 1 : 0.5"
                     class="mr-1"
                     (click)="updateProducts()"></button>
                  <button
                     [label]="isUpdateFinished ? 'Close' : 'Cancel'"
                     pButton
                     type="button"
                     icon="pi pi-times"
                     (click)="handleCloseButton()"></button>
               </ng-template>
            </p-dialog>
         </div>

         <div style="display: inline-flex; float: right; margin-right: 13px">
            <button
			   type="button"
			   id="smsModalButton"
			   class="v-button v-button-md v-green"
			   (click)="showCSVModal(true)">
			   <i class="pi pi-upload"></i>
			   &nbsp;&nbsp;Update <strong>VC Products</strong> Import CSV
			</button>
         </div>

         <div
            class="tab-content"
            style="background: #ffffff; padding: 5px 20px 0px 20px">
            <div
               class="tab-pane show active"
               id="all_tasks">
               <div
                  class="vetcorSortFilters dropdown"
                  style="margin-top: 20px; margin-bottom: 20px; display: inline-block; vertical-align: top; margin-right: 7px">
                  <button
                     class="btn btn-secondary dropdown-toggle"
                     alt="Filter options"
                     title="Filter options"
                     style="background: #ffffff; color: #495057; border: 1px solid rgba(145, 158, 171, 0.3); height: 39px; font-size: 14px"
                     type="button"
                     id="filterDropdown"
                     data-bs-toggle="dropdown"
                     aria-expanded="false">
                     <i class="las la-filter me-2"></i>
                     Filter by
                     <b>{{ selectedCategory }}</b>
                     Category &nbsp;
                  </button>
                  <div
                     class="dropdown-menu p-4"
                     aria-labelledby="filterDropdown"
                     style="width: 360px">
                     <div
                        class="filter-set-view"
                        style="text-align: right">
                        <div class="accordion-item filter-set-content">
                           <div class="filter-set-contents">
                              <select
                                 class="form-control"
                                 style="height: 40px"
                                 [(ngModel)]="selectedCategory"
                                 (change)="loadInitialProducts()"
                                 onchange="document.body.click()">
                                 <option value="">All Categories</option>
                                 <option
                                    *ngFor="let category of categories"
                                    [value]="category.vcCatName">
                                    {{ category.vcCatName }}
                                 </option>
                              </select>
                           </div>
                        </div>

                        <button
                           class="btn btn-outline-secondary mt-2 ms-2"
                           (click)="resetFilters()"
                           style="margin-right: 10px">
                           Reset
                        </button>
                        <button
                           class="btn btn-primary mt-2"
                           (click)="applyFilters()">
                           Apply Filters
                        </button>
                     </div>
                  </div>
               </div>

               <div
                  class="search-set"
                  style="margin-top: 20px; margin-bottom: 20px; display: inline-block">
                  <div class="search-input">
                     <a
                        href="javascript:void(0);"
                        (click)="search()"
                        class="btn btn-searchset">
                        <i class="las la-search"></i>
                     </a>
                     <div class="dataTables_filter">
                        <label>
                           <input
                              [(ngModel)]="searchTerm"
                              [ngModelOptions]="{ standalone: true }"
                              (input)="search()"
                              type="search"
                              class="form-control"
                              style="width: 500px"
                              placeholder="Search..." />
                        </label>
                     </div>
                  </div>
               </div>
			   
			   <div
                  class="search-set" style="margin-top: 15px; display: inline-block; float: right">
                  <button
					   type="button"
					   class="v-button v-button-md v-white"
					   id="smsModalButton"
					   data-bs-toggle="modal"
					   data-bs-target="#add_product">
					   <i class="fa fa-file-medical"></i>
					   &nbsp;&nbsp;Add New VC Product
			      </button>
               </div>

               <div
                  class="row"
                  style="margin-top: 10px">
                  <div class="col-md-12">
                     <div
                        class="table-responsive"
                        style="height: calc(100vh - 320px); overflow: auto; margin-bottom: 40px;">
                        <vc-spinner *ngIf="loading"></vc-spinner>
                        <cdk-virtual-scroll-viewport
                           *ngIf="!loading"
                           itemSize="61"
                           class="example-viewport">
                           <table matSort (matSortChange)="sortData($event)" class="table table-striped custom-table datatable contact-table">
                              <thead>
                                 <tr>
                                    <th mat-sort-header="id" style="width: 5%">ID</th>
                                    <th mat-sort-header="description" style="width: 19%">Description</th>
									<th mat-sort-header="msrp" style="width: 6%">MSRP</th>
									<th mat-sort-header="map" style="width: 6%">MAP</th>
                                    <th mat-sort-header="type" style="width: 9%">Type</th>
                                    <th mat-sort-header="category" style="width: 13%">Category</th>
									<th mat-sort-header="vetcoveProductName" style="width: 15%">Competitor Product</th>
									<th mat-sort-header="vetcoveProductId" style="width: 6%; white-space: pre-wrap;">Vetcove Id</th>									
									<th mat-sort-header="vetcoveMatchCriteria" style="width: 6%; white-space: pre-wrap;">Vetcove  Conversion</th>
                                    <th mat-sort-header="code" style="width: 7%; white-space: pre-wrap;">ezy Vet Code</th>
                                    <th class="text-end" style="width: 12%; text-align: right; padding-right: 15px"> </th>
                                 </tr>
                              </thead>
                              <tbody class="dashboardFaxRows">
                                 <tr *cdkVirtualFor="let product of products; trackBy: trackByFn">
                                    <td style="width: 5%">V0{{ product.id }}</td>
                                    <td style="width: 19%; white-space: pre-wrap; text-align: left">
                                       <div *ngIf="!product.isEditing">{{ product.description?.trim() }}</div>
                                       <div *ngIf="product.isEditing">
                                          <input
                                             [(ngModel)]="product.description"
                                             type="text"
                                             class="form-control"
                                             style="height: 40px"
                                             (blur)="product.description = product.description?.trim()" />
                                       </div>
                                    </td>
									<td style="width: 6%">
                                       <div *ngIf="!product.isEditing">{{ product.msrp | currency : "USD" : "symbol" : "1.2-2" }}</div>
                                       <div *ngIf="product.isEditing">
                                          <input
                                             [(ngModel)]="product.msrp"
                                             type="text"
                                             class="form-control"
                                             style="height: 40px"
                                             (blur)="product.msrp = product.msrp?.trim()" />
                                       </div>
                                    </td>
									<td style="width: 6%">
                                       <div *ngIf="!product.isEditing">{{ product.map | currency : "USD" : "symbol" : "1.2-2" }}</div>
                                       <div *ngIf="product.isEditing">
                                          <input
                                             [(ngModel)]="product.map"
                                             type="text"
                                             class="form-control"
                                             style="height: 40px"
                                             (blur)="product.map = product.map?.trim()" />
                                       </div>
                                    </td>
                                    <td style="width: 9%">
                                       <div *ngIf="!product.isEditing">{{ getProductType(product.type) }}</div>
                                       <div *ngIf="product.isEditing">
                                          <select
                                             [(ngModel)]="product.type"
                                             class="form-control"
                                             style="height: 40px">
                                             <option [value]="1">Inventory</option>
                                             <option [value]="2">Service</option>
                                          </select>
                                       </div>
                                    </td>
                                    <td class="competitorTd" style="width: 13%; white-space: pre-wrap;">
                                       <div *ngIf="!product.isEditing">
									      <a href="javascript:void(0);"
											 data-bs-toggle="modal"
											 (click)="openCategoryUpdateModal(product)"
											 data-bs-target="#update_category_info">
										     {{ product.category }}
										  </a>
									   </div>
                                       <div *ngIf="product.isEditing">
                                          <select
                                             [(ngModel)]="product.vcSKey"
                                             (change)="onCategoryChange(product, $event)"
                                             class="form-control"
                                             style="height: 40px">
                                             <option
                                                *ngFor="let category of categories"
                                                [value]="category.vcSKey">
                                                {{ category.vcCatName }}
                                             </option>
                                          </select>
                                       </div>
                                    </td>
									<td class="competitorTd" style="width: 15%; white-space: pre-wrap;">
									   <div *ngIf="!product.isEditing">
									      <a [href]="product.vetcoveProductLink" target="_blank">{{ product.vetcoveProductName }}</a>
									   </div>
									   <div *ngIf="product.isEditing">
									      <input type="text"
										     placeholder="Search product"
											 class="form-control"
											 [(ngModel)]="product.vetcoveProductName"
											 (ngModelChange)="onProductSearch($event)"
											 style="height: 40px; width: 100%"
											 [matAutocomplete]="auto">
										  <mat-autocomplete #auto="matAutocomplete"
                                             (optionSelected)="onProductSelected(product, $event.option.value, $event.option.viewValue)">
										     <mat-option *ngFor="let vetcoveProduct of filteredVetcoveProducts | async"
										        [value]="vetcoveProduct.vetcoveId">
											       {{ vetcoveProduct.name }}
										     </mat-option>
										  </mat-autocomplete>
									  </div>
									</td>
									<td style="width: 6%">
                                       <div *ngIf="!product.isEditing">{{ product.vetcoveProductId }}</div>
                                       <div *ngIf="product.isEditing">
                                          <input
                                             [(ngModel)]="product.vetcoveProductId"
                                             type="text"
                                             class="form-control"
											 (blur)="onVetcoveIdBlur(product)"
                                             style="height: 40px" />
                                       </div>
                                    </td>
									<td style="width: 6%">
                                       <div *ngIf="!product.isEditing">{{ product.vetcoveMatchCriteria }}</div>
                                       <div *ngIf="product.isEditing">
                                          <input
                                             [(ngModel)]="product.vetcoveMatchCriteria"
                                             type="text"
                                             class="form-control"
                                             style="height: 40px"
                                             (blur)="product.vetcoveMatchCriteria = product.vetcoveMatchCriteria?.trim()" />
                                       </div>
                                    </td>
                                    <td style="width: 7%">{{ product.code }}</td>

                                    <td style="text-align: right; width: 12%">
                                       <button
                                          *ngIf="!product.isEditing"
                                          type="button"
                                          class="v-button v-button-sm v-blue mr-2"
                                          (click)="openMergeModal(product)">
                                          <i class="fa fa-arrows-alt-h"></i>
                                          &nbsp;Merge
                                       </button>
                                       <button
                                          id="mergeModalButton"
                                          data-bs-toggle="modal"
                                          data-bs-target="#mergeModal"
                                          style="display: none"></button>
                                       <button
                                          id="closeMergeModalButton"
                                          data-bs-dismiss="modal"
                                          data-bs-target="#mergeModal"
                                          style="display: none"></button>

                                       <button
                                          *ngIf="!product.isEditing"
                                          type="button"
                                          class="v-button v-button-sm v-white"
                                          (click)="toggleEdit(product)">
                                          <i class="fa fa-edit"></i>
                                          &nbsp;Edit
                                       </button>
                                       <button
                                          *ngIf="product.isEditing"
                                          type="button"
                                          class="v-button v-button-sm v-white"
                                          (click)="updateProduct(product)">
                                          <i class="fa fa-save"></i>
                                          &nbsp;Save
                                       </button>
                                       <a
                                          href="javascript:void(0);"
                                          *ngIf="product.isEditing"
                                          (click)="onCancel(product)"
                                          style="font-size: 15px; vertical-align: baseline; color: #1d2630; margin-right: 10px;">
                                          &nbsp;&nbsp;&nbsp;
                                          <i
                                             class="fa fa-remove"
                                             style="font-size: 15px"></i>
                                          &nbsp;Cancel
                                       </a>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </cdk-virtual-scroll-viewport>
                     </div>
                  </div>
               </div>
            </div>
            <!-- close first tab -->

            <div
               class="tab-pane"
               id="request_tasks">
               <div
                  class="row"
                  style="margin-top: 10px">
                  <div class="col-md-12">
                     <div
                        class="vetcorSortFilters dropdown"
                        style="margin-top: 5px; margin-bottom: 20px; display: inline-block; vertical-align: top; margin-right: 7px">
                        <button
                           class="btn btn-secondary dropdown-toggle"
                           alt="Filter options"
                           title="Filter options"
                           style="background: #ffffff; color: #495057; border: 1px solid rgba(145, 158, 171, 0.3); height: 39px; font-size: 14px"
                           type="button"
                           id="filterDropdown"
                           data-bs-toggle="dropdown"
                           aria-expanded="false">
                           <i class="las la-filter me-2"></i>
                           Filter by
                           <b>{{ selectedHospital }}</b>
                           Hospital &nbsp;
                        </button>
                        <div
                           class="dropdown-menu p-4"
                           aria-labelledby="filterDropdown"
                           style="width: 360px">
                           <div
                              class="filter-set-view"
                              style="text-align: right">
                              <div class="accordion-item filter-set-content">
                                 <div class="filter-set-contents">
                                    <select
                                       class="form-control"
                                       style="height: 40px"
                                       [(ngModel)]="selectedHospital"
                                       (change)="filterByHospital($event.target.value)"
                                       onchange="document.body.click()">
                                       <option value="">All Hospitals</option>
                                       <option
                                          *ngFor="let hospital of hospitals"
                                          [value]="hospital">
                                          {{ hospital }}
                                       </option>
                                    </select>
                                 </div>
                              </div>

                              <button
                                 class="btn btn-outline-secondary mt-2 ms-2"
                                 (click)="resetHospitalFilters()"
                                 style="margin-right: 10px">
                                 Reset
                              </button>
                           </div>
                        </div>
                     </div>

                     <div
                        style="
                           margin-top: 10px;
                           display: inline-block;
                           vertical-align: middle;
                           margin-right: 7px;
                           margin-left: 15px;
                           font-size: 13px;
                           font-weight: 600;
                        ">
                        <span
                           class="badge activity-badge"
                           style="width: auto; font-size: 13px">
                           <i
                              class="fa-regular fa-folder-open"
                              style="font-family: 'Font Awesome 5 Free'; font-style: normal"></i>
                           &nbsp;Open Requests: {{ statusCount1 }}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span
                           class="badge activity-badge"
                           style="width: auto; font-size: 13px">
                           <i
                              class="fa-regular fa-clock"
                              style="font-family: 'Font Awesome 5 Free'; font-style: normal"></i>
                           &nbsp;Pending Requests: {{ statusCount3 }}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span
                           class="badge activity-badge"
                           style="width: auto; font-size: 13px">
                           <i class="la la-clipboard-check"></i>
                           &nbsp;Closed Requests: {{ statusCount2 }}
                        </span>
                     </div>

                     <div
                        class="float-end ms-auto"
                        style="display: inline-block; float: right; margin-top: 5px">
                        <div
                           class="d-flex title-head"
                           style="align-items: baseline; align-items: flex-start">
                           <div class="view-icons">
                              <a
                                 href="javascript:void(0);"
                                 class="grid-view btn btn-link"
                                 style="background-color: #fff; border: 1px solid #e2e4e6; color: #4d5154"
                                 (click)="loadRequests()"
                                 title="Refresh Requests"
                                 alt="Refresh Requests">
                                 <i
                                    class="las la-redo-alt"
                                    style="color: #4d5154"></i>
                              </a>
                              <a
                                 href="javascript:void(0);"
                                 class="list-view btn btn-link"
                                 style="background-color: #fff; border: 1px solid #e2e4e6; color: #4d5154"
                                 id="collapse-header"
                                 alt="View Fullscreen"
                                 title="View Fullscreen"
                                 (click)="fullscreen()">
                                 <i
                                    class="las la-expand-arrows-alt"
                                    style="color: #4d5154"></i>
                              </a>
                           </div>

                           <div
                              class="float-end ms-auto"
                              style="display: inline-block; margin-right: -9px">
                              <div
                                 class="d-flex title-head"
                                 style="align-items: baseline; align-items: flex-start; display: inline-flex !important">
                                 <div class="view-icons">
                                    <a
                                       href="javascript:void(0);"
                                       class="list-view btn btn-link exportButton"
                                       style="
                                          font-size: 15px;
                                          padding: 9px 18px;
                                          background-color: #fff !important;
                                          border: 1px solid #e2e4e6 !important;
                                          color: #4d5154 !important;
                                       "
                                       title="Export Table"
                                       alt="Export Table"
                                       data-bs-toggle="modal"
                                       data-bs-target="#export">
                                       <i
                                          class="las la-file-export"
                                          style="font-size: 14px; color: #4d5154"></i>
                                       Export
                                    </a>
                                 </div>
                              </div>

                              <!--<div class="d-flex title-head" style="align-items: baseline; align-items: flex-start; display:inline-flex !important; margin-left:-9px">
					<div class="view-icons">
						<a href="javascript:void(0);" class="list-view btn btn-link exportButton" style="font-size: 15px; padding: 9px 18px; background-color: #fff !important; border: 1px solid #e2e4e6 !important; color: #4d5154 !important;" title="Import" alt="Import" data-bs-toggle="modal" data-bs-target="#import"><i class="fa fa-arrow-alt-circle-down" style="color: transparent; -webkit-text-stroke-width: 0.7px; font-size:14px; -webkit-text-stroke-color: #4d5154; margin-right:1px"></i> Import</a>		
					</div>
				</div>-->
                           </div>

                           <button
                              type="button"
                              class="btn btn-primary requestSave"
                              style="display: inline-block"
                              (click)="updateRequests()">
                              <i class="fa fa-save"></i>
                              Save All Changes
                           </button>
                        </div>
                     </div>

                     <div
                        class="table-responsive"
                        style="height: calc(100vh - 320px); overflow: auto; margin-bottom: 40px">
                        <vc-spinner *ngIf="loadingRequests"></vc-spinner>
                        <cdk-virtual-scroll-viewport
                           *ngIf="!loadingRequests"
                           itemSize="38"
                           class="example-viewport-review-requests">
                           <table
                              matSort
                              (matSortChange)="sortRequests($event)"
                              class="table table-striped custom-table datatable contact-table">
                              <thead>
                                 <tr>
                                    <th
                                       mat-sort-header="hospital"
                                       style="max-width: 130px; width: 130px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Hospital
                                    </th>
                                    <th
                                       mat-sort-header="requestedByName"
                                       style="max-width: 100px; width: 100px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Requested By
                                    </th>
                                    <th
                                       mat-sort-header="dateRequested"
                                       style="max-width: 85px; width: 85px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Date Req.
                                    </th>
                                    <th
                                       mat-sort-header="legacyCode"
                                       style="max-width: 70px; width: 70px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Code
                                    </th>
                                    <th
                                       mat-sort-header="productName"
                                       style="max-width: 120px; width: 120px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Product Name
                                    </th>
                                    <th
                                       mat-sort-header="revCategory"
                                       style="max-width: 120px; width: 120px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Rev. Category
                                    </th>
                                    <th
                                       mat-sort-header="supportNote"
                                       style="max-width: 125px; width: 125px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Support Note
                                    </th>
                                    <th style="max-width: 120px; width: 120px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       <div class="status-toggle-container">
                                          <button
                                             [class.active]="isStatusSelected(1)"
                                             (click)="toggleStatusFilter(1)"
                                             title="Open"
                                             alt="Open">
                                             <!--<span class="status-circle" [class.checked]="isStatusSelected(1)"></span>-->
                                             <i
                                                class="fa-regular fa-folder-open"
                                                style="font-family: 'Font Awesome 5 Free'; font-style: normal"></i>
                                          </button>
                                          <button
                                             [class.active]="isStatusSelected(3)"
                                             (click)="toggleStatusFilter(3)"
                                             title="Pending"
                                             alt="Pending">
                                             <!--<span class="status-circle" [class.checked]="isStatusSelected(3)"></span>-->
                                             <i
                                                class="fa-regular fa-clock"
                                                style="font-family: 'Font Awesome 5 Free'; font-style: normal"></i>
                                          </button>
                                          <button
                                             [class.active]="isStatusSelected(2)"
                                             (click)="toggleStatusFilter(2)"
                                             title="Closed"
                                             alt="Closed">
                                             <!-- <span class="status-circle" [class.checked]="isStatusSelected(2)"></span>-->
                                             <i class="la la-clipboard-check"></i>
                                          </button>
                                       </div>
                                    </th>
                                    <th
                                       mat-sort-header="action"
                                       style="max-width: 115px; width: 115px; padding-left: 10px; padding-right: 10px; text-align: left">
                                       Action
                                    </th>
                                    <th style="width: 190px; max-width: 190px; padding-left: 10px; padding-right: 10px; text-align: right">
                                       Review Question & Feedback
                                    </th>
                                 </tr>
                              </thead>
                              <tbody class="dashboardFaxRows">
                                 <tr *cdkVirtualFor="let productRequest of statusFilteredRequests; trackBy: trackByFn">
                                    <td
                                       style="
                                          max-width: 130px;
                                          width: 130px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.hospital }}
                                    </td>
                                    <td
                                       style="
                                          max-width: 100px;
                                          width: 100px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.requestedByName }}
                                    </td>
                                    <td
                                       style="
                                          max-width: 85px;
                                          width: 85px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.dateRequested | date : "M/d/yyyy" }}
                                    </td>
                                    <td
                                       style="
                                          max-width: 70px;
                                          width: 70px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.legacyCode }}
                                    </td>
                                    <td
                                       style="
                                          max-width: 120px;
                                          width: 120px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.productName }}
                                    </td>
                                    <td
                                       style="
                                          max-width: 120px;
                                          width: 120px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       {{ productRequest.revCategory }}
                                    </td>

                                    <td
                                       style="
                                          max-width: 125px;
                                          width: 125px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          white-space: normal;
                                          text-align: left;
                                       ">
                                       <button
                                          id="notesModalButton"
                                          data-bs-toggle="modal"
                                          data-bs-target="#notesModal"
                                          style="display: none"></button>
                                       <p-button
                                          *ngIf="productRequest.supportNote != ''"
                                          class="adminSupportNote_onlyadmin"
                                          (onClick)="
                                             openNotesModal(
                                                productRequest.productSKey,
                                                productRequest.supportNote,
                                                productRequest.dateRequested,
                                                productRequest.action
                                             )
                                          "
                                          [attr.data-count]="getNotesCount(productRequest.productSKey)">
                                          {{ truncateText(productRequest.supportNote, 37) }}
                                       </p-button>
                                    </td>

                                    <td style="max-width: 120px; width: 120px; padding-left: 10px; padding-right: 10px">
                                       <span
                                          *ngIf="getStatusType(productRequest.status) == 'Pending'"
                                          class="badge activity-badge badge-bg-sms"
                                          style="font-size: 12px; vertical-align: baseline; max-width: 85px">
                                          <i
                                             *ngIf="getStatusType(productRequest.status) == 'Pending'"
                                             class="fa-regular fa-clock"
                                             style="font-size: 12px; margin-right: 4px; font-family: 'Font Awesome 5 Free'; font-style: normal"></i>
                                          {{ getStatusType(productRequest.status) }}
                                       </span>
                                       <span
                                          *ngIf="getStatusType(productRequest.status) == 'Closed'"
                                          class="badge activity-badge badge-bg-complete"
                                          style="font-size: 12px; vertical-align: baseline; max-width: 85px">
                                          <i
                                             *ngIf="getStatusType(productRequest.status) == 'Closed'"
                                             class="la la-clipboard-check"
                                             style="font-size: 12px; margin-right: 4px"></i>
                                          {{ getStatusType(productRequest.status) }}
                                       </span>
                                       <span
                                          *ngIf="getStatusType(productRequest.status) == 'Open'"
                                          class="badge activity-badge badge-bg-pending"
                                          style="font-size: 12px; vertical-align: baseline; max-width: 85px">
                                          <i
                                             *ngIf="getStatusType(productRequest.status) == 'Open'"
                                             class="fa fa-folder-open"
                                             style="font-size: 12px; margin-right: 4px"></i>
                                          {{ getStatusType(productRequest.status) }}
                                       </span>
                                    </td>
                                    <td style="max-width: 115px; width: 115px; padding-left: 10px; padding-right: 10px">
                                       <span
                                          *ngIf="productRequest.action == 3"
                                          style="font-weight: 600; padding-left: 3px; text-align: center; color: #009efb; font-size: 13px">
                                          CLOSED
                                       </span>

                                       <div
                                          *ngIf="productRequest.action != 3"
                                          class="btn-group"
                                          style="">
                                          <select
                                             [(ngModel)]="productRequest.action"
                                             (change)="changeAction(productRequest)"
                                             class="form-control form-control-sm btn btn-outline-secondary dropdown-toggle requestActionsDrop"
                                             style="width: 90px">
                                             <option
                                                [value]="0"
                                                disabled
                                                hidden
                                                selected>
                                                Action
                                             </option>
                                             <option [value]="1">Need More Information</option>
                                             <option [value]="2">Declined</option>
                                             <option [value]="3">Approved</option>
                                          </select>
                                          <button
                                             id="vcLinkModalButton"
                                             data-bs-toggle="modal"
                                             data-bs-target="#vcLinkModal"
                                             style="display: none"></button>
                                          <button
                                             id="closeVCLinkModalButton"
                                             data-bs-dismiss="modal"
                                             data-bs-target="#vcLinkModal"
                                             style="display: none"></button>
                                       </div>
                                    </td>
                                    <td
                                       style="
                                          width: 190px;
                                          max-width: 190px;
                                          padding-left: 10px;
                                          padding-right: 10px;
                                          float: right;
                                          margin-right: 5px;
                                       ">
                                       <span
                                          *ngIf="productRequest.action == 3"
                                          style="font-weight: 500; font-style: italic; padding-left: 3px; vertical-align: -webkit-baseline-middle">
                                          {{ productRequest.adminFeedback }}
                                       </span>

                                       <textarea
                                          *ngIf="productRequest.action != 3"
                                          [(ngModel)]="productRequest.adminFeedback"
                                          class="form-control form-control-sm adminFeedback"
                                          rows="3"
                                          placeholder="Admin question or feedback"
                                          >{{ productRequest.adminFeedback }}</textarea
                                       >
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </cdk-virtual-scroll-viewport>
                     </div>
                  </div>
               </div>
            </div>
            <!-- close second tab -->
         </div>
      </div>
      <!-- close all tabs -->
   </div>
   <!-- close container -->
</div>
<!-- close vetcor new styles -->

<div
   class="modal custom-modal fade"
   id="add_product"
   role="dialog">
   <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-body">
            <div class="success-message text-center">
               <div
                  class="success-popup-icon v-greenbg mt-2">
                  <h2 class="mb-0">
				     <i class="fa fa-paw v-whitecolor"></i>
			      </h2>
               </div>
               <h3 class="mb-2">Add a New Product</h3>
               <div>
				<form #productForm="ngForm" (ngSubmit)="addProduct()" class="mt-4 col-lg-12 text-center">
				 <table><tr>
				  <td>
				   <p class="col-lg-12 mt-3 mb-4">
					<label>Description</label>
					<input
                        type="text"
                        [(ngModel)]="newProduct.description"
                        name="description"
                        placeholder="Description"
                        class="form-control p-inputtext"
                        required />
				   </p>
				  
				   <p class="col-lg-12 mt-3 mb-4">
					<label>MSRP</label>
					<input
					    type="number"
					    step="any"
					    [ngModel]="newProduct.msrp"
					    (ngModelChange)="newProduct.msrp = toFloat($event)"
					    name="msrp"
					    placeholder="MSRP"
					    class="form-control p-inputtext" />
				   </p>
				   
				   <p class="col-lg-12 mt-3 mb-4">
					<label>MAP</label>
					<input
					    type="number"
					    step="any"
					    [ngModel]="newProduct.map"
					    (ngModelChange)="newProduct.map = toFloat($event)"
					    name="map"
					    placeholder="MAP"
					    class="form-control p-inputtext" />
				   </p>
				  
				   <p class="col-lg-12 mt-3 mb-4">
					<label>Category</label>
					<select
                        id="category"
                        [(ngModel)]="newProduct.category"
                        name="category"
                        class="form-control p-select"
                        required>
                        <option
                           value=""
                           disabled
                           hidden
                           selected>
                           Select a category...
                        </option>
                        <option
                           *ngFor="let category of categories"
                           [value]="category.vcSKey">
                           {{ category.vcCatName }}
                        </option>
                     </select>
				   </p>
				  </td>
				  
				  <td style="vertical-align: top">				  
				   <p class="col-lg-12 mt-3 mb-4">
					<label>Product Type</label>
					<select
                        id="type"
                        [(ngModel)]="newProduct.type"
                        name="type"
                        class="form-control p-select"
                        required>
                        <option
                           value=""
                           disabled
                           hidden
                           selected>
                           Select product type...
                        </option>
                        <option value="1">Inventory</option>
                        <option value="2">Service</option>
                     </select>
				   </p>
				  
				   <p class="col-lg-12 mt-3 mb-4">
					<label>Competitor Product</label>
					<input type="text"
					    placeholder="Competitor Product"
						class="form-control p-inputtext"
					    [(ngModel)]="newProduct.vetcoveProductName"
					    (ngModelChange)="onProductSearch($event)"
					    [ngModelOptions]="{standalone: true}"
					    [matAutocomplete]="auto">
				     <mat-autocomplete #auto="matAutocomplete"
					    (optionSelected)="onProductSelected(newProduct, $event.option.value, $event.option.viewValue)">
					    <mat-option *ngFor="let vetcoveProduct of filteredVetcoveProducts | async"
						   [value]="vetcoveProduct.vetcoveId">
						      {{ vetcoveProduct.name }}
					    </mat-option>
				     </mat-autocomplete>
				   </p>
				  
				   <p class="col-lg-12 mt-3 mb-4">
					<label>Vetcove Match Conversion</label>
					<input
					    type="number"
					    step="any"
					    [ngModel]="newProduct.vetcoveMatchCriteria"
					    (ngModelChange)="newProduct.vetcoveMatchCriteria = toFloat($event)"
					    name="vetcoveMatchCriteria"
					    placeholder="Vetcove Match Conversion"
					    class="form-control p-inputtext" />
				   </p>
				  </td>
				  </tr></table>

				  <div class="col-lg-12 text-center form-wizard-button mt-4 mb-3">
					<button 
					   type="button"
					   class="v-button v-button-lg v-gray mr-2"
					   data-bs-dismiss="modal">
					   Cancel
					</button>
					<button
					  type="submit"
					  class="v-button v-button-lg v-green ml-2"
					  data-bs-dismiss="modal">
					  Add
					</button>
				  </div>
				</form>
			  </div>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   class="modal custom-modal fade"
   id="update_category_info"
   role="dialog">
   <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-body">
            <div class="success-message text-center">
               <div
                  class="success-popup-icon v-greenbg mt-2">
                  <h2 class="mb-0">
				     <i class="fa fa-paw v-whitecolor"></i>
			      </h2>
               </div>
               <h3 class="mb-2">Update Category</h3>
               <div *ngIf="clickedCategory as cp">
				<p class="v-graycolor mb-4">{{ cp.category }}</p>

				<form #updateForm="ngForm" (ngSubmit)="updateCategoryInfo()" class="col-lg-12 text-center">
				  <p class="col-lg-12 mb-2">
					<label>Inflation</label>
					<input
					  type="number"
					  step="any"
					  class="form-control p-inputtext"
					  name="inflation"
					  [(ngModel)]="cp.inflation" />
				  </p>

				  <p class="col-lg-12 mt-3 mb-4">
					<label>Elasticity</label>
					<input
					  type="number"
					  step="any"
					  class="form-control p-inputtext"
					  name="elasticity"
					  [(ngModel)]="cp.elasticity" />
				  </p>

				  <div class="col-lg-12 text-center form-wizard-button mt-5 mb-3">
					<button 
					   type="button"
					   class="v-button v-button-lg v-gray mr-2"
					   data-bs-dismiss="modal">
					   Cancel
					</button>
					<button
					  type="submit"
					  class="v-button v-button-lg v-green ml-2"
					  data-bs-dismiss="modal">
					  Save
					</button>
				  </div>
				</form>
			  </div>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   class="modal custom-modal fade"
   id="mergeModal"
   role="dialog"
   #mergeModal
   data-bs-animation="false">
   <div
      class="modal-dialog modal-dialog-centered"
      style="width: 1000px; min-width: 1000px">
      <div
         class="modal-content"
         style="width: 900px; min-width: 100px; border-top: 14px solid #35aad1">
         <div class="modal-body">
            <div class="success-message text-center">
               <!-- <div class="success-popup-icon bg-success" style="background-color:#17a2b8; width:55px; height:55px">
            <i class="fa fa-compress-arrows-alt" style="color:#ffffff; font-size:23px"></i>
          </div>-->
               <h3 style="margin-top: 6px; margin-bottom: 30px; line-height: 25px; font-size: 18px">
                  Search for and select a product below you would like to merge with
                  <br />
                  <span style="font-size: 15px; color: #666666; font-style: italic">** Please be sure to remove this item from ezyVet as well.</span>
               </h3>

               <div
                  class="search-set"
                  style="margin-top: 0px; margin-bottom: 20px; display: inline-block">
                  <div class="search-input">
                     <a
                        href="javascript:void(0);"
                        (click)="searchMerge()"
                        class="btn btn-searchset"
                        style="right: 35px; padding-right: 0px; top: 2px">
                        <i class="las la-search"></i>
                     </a>
                     <div class="dataTables_filter">
                        <label>
                           <input
                              [(ngModel)]="searchMergeTerm"
                              [ngModelOptions]="{ standalone: true }"
                              [ngModelOptions]="{ standalone: true }"
                              (input)="searchMerge()"
                              type="search"
                              class="form-control"
                              style="width: 500px"
                              placeholder="Search..." />
                        </label>
                     </div>
                  </div>
               </div>

               <div *ngIf="mergeCandidates.length > 0">
                  <ul
                     class="list-group list-striped"
                     style="font-size: 14px; max-height: 400px; overflow-y: auto">
                     <li
                        class="list-group-item"
                        *ngFor="let candidate of mergeCandidates"
                        (click)="mergeProduct(candidate)">
                        <b>ID</b>
                        : V0{{ candidate.id }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Category</b>
                        : {{ candidate.category }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Description</b>
                        :
                        <span
                           style="
                              overflow: hidden;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              width: 220px;
                              text-align: left;
                              display: inline-block;
                              vertical-align: bottom;
                           ">
                           {{ candidate.description }}
                        </span>
                     </li>
                  </ul>
               </div>
               <div *ngIf="mergeCandidates.length === 0">No merge candidates found.</div>

               <div class="col-lg-12 text-center form-wizard-button">
                  <button
                     type="button"
                     class="button btn-lights"
                     data-bs-dismiss="modal"
                     (click)="closeModal()">
                     Cancel
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   class="modal custom-modal fade"
   id="vcLinkModal"
   role="dialog"
   #vcLinkModal
   data-bs-animation="false">
   <div
      class="modal-dialog modal-dialog-centered"
      style="width: 1000px; min-width: 1000px">
      <div
         class="modal-content"
         style="width: 900px; min-width: 100px; border-top: 14px solid #35aad1">
         <div class="modal-body">
            <div class="success-message text-center">
               <!-- <div class="success-popup-icon bg-success" style="background-color:#17a2b8; width:55px; height:55px">
            <i class="fa fa-compress-arrows-alt" style="color:#ffffff; font-size:23px"></i>
          </div>-->
               <h3 style="margin-top: 6px; margin-bottom: 30px; line-height: 25px; font-size: 18px">
                  Select which VC product you are linking to this PIMS product
                  <br />
                  ({{ selectedPIMSProductName }}):
               </h3>

               <div
                  class="search-set"
                  style="margin-top: 0px; margin-bottom: 20px; display: inline-block">
                  <div class="search-input">
                     <a
                        href="javascript:void(0);"
                        (click)="searchVCLink()"
                        class="btn btn-searchset"
                        style="right: 35px; padding-right: 0px; top: 2px">
                        <i class="las la-search"></i>
                     </a>
                     <div class="dataTables_filter">
                        <label>
                           <input
                              [(ngModel)]="searchVCLinkTerm"
                              [ngModelOptions]="{ standalone: true }"
                              [ngModelOptions]="{ standalone: true }"
                              (input)="searchVCLink()"
                              type="search"
                              class="form-control"
                              style="width: 500px"
                              placeholder="Search..." />
                        </label>
                     </div>
                  </div>
               </div>

               <div *ngIf="vcLinkCandidates.length > 0">
                  <ul
                     class="list-group list-striped"
                     style="font-size: 14px; max-height: 400px; overflow-y: auto">
                     <li
                        class="list-group-item"
                        *ngFor="let candidate of vcLinkCandidates"
                        (click)="vcLinkProduct(candidate)">
                        <b>ID</b>
                        : V0{{ candidate.id }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Category</b>
                        : {{ candidate.category }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Description</b>
                        :
                        <span
                           style="
                              overflow: hidden;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              width: 220px;
                              text-align: left;
                              display: inline-block;
                              vertical-align: bottom;
                           ">
                           {{ candidate.description }}
                        </span>
                     </li>
                  </ul>
               </div>
               <div *ngIf="vcLinkCandidates.length === 0">No candidates found.</div>

               <div class="col-lg-12 text-center form-wizard-button">
                  <button
                     type="button"
                     class="button btn-lights"
                     data-bs-dismiss="modal"
                     (click)="closeModal()">
                     Cancel
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   class="modal custom-modal fade modal-padding"
   id="notesModal"
   role="dialog">
   <div
      class="modal-dialog modal-dialog-centered"
      style="width: 1000px; min-width: 1000px">
      <div
         class="modal-content"
         style="width: 900px; min-width: 100px">
         <div class="modal-header header-border align-items-center justify-content-between p-0">
            <h5 class="modal-title">Notifications</h5>
            <button
               type="button"
               class="btn-close position-static"
               data-bs-dismiss="modal"
               aria-label="Close"
               style="padding-bottom: 4px">
               <span aria-hidden="true">×</span>
            </button>
         </div>
         <div class="modal-body p-0">
            <vc-spinner *ngIf="loadingMapNotes"></vc-spinner>
            <span *ngIf="!loadingMapNotes">
               <div
                  class="calls-box"
                  style="margin-bottom: 30px">
                  <div
                     class="calls-action"
                     style="display: inline-block; align-items: center; float: right">
                     <span
                        *ngIf="selectedNoteAction == 0"
                        class="openBadge">
                        <i
                           *ngIf="selectedNoteAction == 0"
                           class="fa fa-folder-open"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Open
                     </span>
                     <span
                        *ngIf="selectedNoteAction == 1"
                        class="moreInfoBadge">
                        <i
                           *ngIf="selectedNoteAction == 1"
                           class="fa fa-exclamation"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Need More Information
                     </span>
                     <span
                        *ngIf="selectedNoteAction == 2"
                        class="declinedBadge">
                        <i
                           *ngIf="selectedNoteAction == 2"
                           class="la la-remove"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Declined
                     </span>
                     <span
                        *ngIf="selectedNoteAction == 3"
                        class="approvedBadge">
                        <i
                           *ngIf="selectedNoteAction == 3"
                           class="fa fa-check"
                           style="font-size: 12px; margin-right: 4px"></i>
                        Approved
                     </span>
                  </div>
                  <div class="reply-box">
                     <div
                        class="calls-user"
                        style="display: inline-flex; align-items: center">
                        <i class="notesUser fa fa-user"></i>
                        <div>
                           <h6 style="font-size: 15px; font-weight: 500; margin-bottom: 0px; color: #373b3e">User</h6>
                           <p style="font-size: 14px; margin-bottom: 0px">{{ selectedNoteDate | date : "M/d/yyyy h:mm a" }}</p>
                        </div>
                     </div>
                     <p style="margin-bottom: 15px; margin-top: 15px; font-size: 14px">
                        <span [innerHTML]="selectedNoteNote"></span>
                     </p>
                  </div>
               </div>

               <div
                  *ngFor="let productMapNote of productMapNotes"
                  class="calls-box"
                  style="margin-left: 40px">
                  <div
                     *ngIf="productMapNote.isAdmin == 1"
                     class="caller-info"
                     style="background: #f9f9f9; border-radius: 5px; margin: 0 0 15px; padding: 15px">
                     <div
                        class="calls-user"
                        style="display: inline-flex; align-items: center">
                        <i class="notesUser fa fa-hospital-user"></i>
                        <div>
                           <h6 style="font-size: 15px; font-weight: 500; margin-bottom: 0px; color: #373b3e">Admin</h6>
                           <p style="font-size: 14px; margin-bottom: 0px">{{ productMapNote.timestamp | date : "M/d/yyyy h:mm a" }}</p>
                        </div>
                     </div>
                     <p style="font-size: 14px; margin-bottom: 15px; margin-top: 15px">
                        <span [innerHTML]="productMapNote.feedback"></span>
                     </p>
                  </div>

                  <div
                     *ngIf="productMapNote.isAdmin == 0 && productMapNote.feedback != selectedNoteNote"
                     class="reply-box"
                     style="margin-bottom: 20px; margin-left: 15px">
                     <p style="margin-bottom: 10px; font-size: 14px">
                        <span [innerHTML]="productMapNote.feedback"></span>
                     </p>
                     <p style="margin-bottom: 10px; font-size: 14px">
                        <i
                           class="notesUser fa fa-user"
                           style="font-size: 12px; height: 25px; width: 25px; line-height: 24px"></i>
                        <i>User responded on {{ productMapNote.timestamp | date : "M/d/yyyy h:mm a" }}</i>
                     </p>
                  </div>
               </div>
            </span>
         </div>
      </div>
   </div>
</div>

<!-- Export -->
<div
   class="modal custom-modal fade modal-padding"
   id="export"
   role="dialog">
   <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-header header-border justify-content-between p-0">
            <h5 class="modal-title">Export Approved Codes</h5>
            <button
               type="button"
               class="btn-close position-static"
               data-bs-dismiss="modal"
               aria-label="Close">
               <span aria-hidden="true">×</span>
            </button>
         </div>
         <div class="modal-body p-0">
            <form>
               <div class="row">
                  <div class="col-md-6">
                     <div class="input-block mb-3">
                        <label
                           class="col-form-label"
                           id="basic-addon1">
                           From Date
                           <span class="text-danger">*</span>
                        </label>

                        <input
                           type="date"
                           class="form-control floating"
                           [(ngModel)]="fromDate"
                           name="fromDate"
                           id="fromDate"
                           style="font-size: 13px" />
                     </div>
                  </div>
                  <div class="col-md-6">
                     <div class="input-block mb-3">
                        <label
                           class="col-form-label"
                           id="basic-addon2">
                           To Date
                           <span class="text-danger">*</span>
                        </label>

                        <input
                           type="date"
                           class="form-control floating"
                           [(ngModel)]="toDate"
                           id="toDate"
                           name="toDate"
                           style="font-size: 13px" />
                     </div>
                  </div>
                  <div class="col-lg-12 text-end form-wizard-button">
                     <button
                        class="button btn-lights reset-btn"
                        type="reset"
                        data-bs-dismiss="modal">
                        Reset
                     </button>
                     <button
                        class="btn btn-primary"
                        type="submit"
                        (click)="exportToCSV()">
                        Export Now
                     </button>
                  </div>
               </div>
            </form>
         </div>
      </div>
   </div>
</div>
<!-- Export -->
